import ListKeyingRuleInput from './index';
// 这个组件是给列表型组件（比如卡片列表）的 “keyingRule” prop 使用的
const ListKeyingRuleInputMeta = {
  id: 'listKeyingRuleInput',
  component: ListKeyingRuleInput,
  bindings: [{
    id: 'v-model',
    prop: 'value',
    event: 'change',
    main: true,
    required: true
  }],
  fitData: () => null,
  propsSchema: {
    type: 'object',
    fields: []
  }
};
export default ListKeyingRuleInputMeta;
//# sourceMappingURL=meta.js.map
